import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository, IStorageService } from '../../../domain/ports';
import type { UserProfile } from '../../dto/dtos';

export class GetProfileUseCase implements IUseCase<void, UserProfile> {
  constructor(
    private readonly authRepository: IAuthRepository,
    private readonly storageService: IStorageService,
  ) {}

  async execute(): Promise<UserProfile> {
    const response = await this.authRepository.getProfile();

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Impossible de recuperer le profil');
    }

    const userData: UserProfile = {
      ...response.data,
      dateCreation: response.data.dateCreation ? new Date(response.data.dateCreation) : new Date(),
      derniereMiseAJour: response.data.derniereMiseAJour ? new Date(response.data.derniereMiseAJour) : undefined,
      lastPasswordChange: response.data.lastPasswordChange ? new Date(response.data.lastPasswordChange) : undefined,
    };

    this.storageService.setUser(userData);
    return userData;
  }
}
